var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment max-width"},[_c('div',{class:_vm.paymentBtn,on:{"click":_vm.payClick}},[_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }